module.exports = __webpack_public_path__ + "img/avatar.7ff07b4d.svg";